export const TEST_ID = 'applicationFormFields';

export const APPLICATION_NAME_FIELD_NAME = 'name';

export const DRONES_FIELD_NAME = 'drones';

export const BATTERIES_FIELD_NAME = 'batteries';

export const PILOT_IDS_FIELD_NAME = 'pilotIds';

export const BOUNDARY_ID_FIELD_NAME = 'boundaryId';

export const FIELD_FIELD_NAME = 'field';

export const CLIENT_FIELD_NAME = 'client';

export const FARM_FIELD_NAME = 'farm';

export const MIX_FIELD_NAME = 'mix';
